// ============================================================================
// CHU-LIU-EDMONDS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'chu-liu-edmonds',
  name: 'Chu-Liu-Edmonds',
  category: 'Graphs',
  complexity: {
    time: 'O(VE)',
    space: 'O(V)'
  },
  description: 'An algorithm for finding maximum spanning arborescences (directed maximum spanning trees) in directed graphs. It uses a greedy approach with cycle contraction.'
};
